

import publicReq, { privateReq, imageUpload } from "./axiosConfig";

export const addFaqService = (data) => privateReq.post("/faq/add-faq", data);
export const getAllFaqs = (data) => privateReq.get("/all-faqs" + data);
export const updateFaqService = (data) => privateReq.post("/update-faq", data);
export const deleteFaqService = (data) => privateReq.delete("/delete-faq/" + data.id);